/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SunshineInternalDtoAdminUsersUserRole,
    SunshineInternalDtoAdminUsersUserRoleFromJSON,
    SunshineInternalDtoAdminUsersUserRoleFromJSONTyped,
    SunshineInternalDtoAdminUsersUserRoleToJSON,
} from './SunshineInternalDtoAdminUsersUserRole';

/**
 * 
 * @export
 * @interface CreateUser
 */
export interface CreateUser {
    /**
     * 
     * @type {string}
     * @memberof CreateUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUser
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUser
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUser
     */
    password: string;
    /**
     * 
     * @type {SunshineInternalDtoAdminUsersUserRole}
     * @memberof CreateUser
     */
    role: SunshineInternalDtoAdminUsersUserRole;
}



export function CreateUserFromJSON(json: any): CreateUser {
    return CreateUserFromJSONTyped(json, false);
}

export function CreateUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'password': json['password'],
        'role': SunshineInternalDtoAdminUsersUserRoleFromJSON(json['role']),
    };
}

export function CreateUserToJSON(value?: CreateUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'password': value.password,
        'role': SunshineInternalDtoAdminUsersUserRoleToJSON(value.role),
    };
}

